module.exports = __webpack_public_path__ + "img/zhga-1.c8f7ee8b.png";